import React from 'react';
import Certificate from "../../../components/pages/form/Certificate/Certificate";

const CertificatePage = () => {
    return <Certificate />
};

export default CertificatePage;
